// extracted by mini-css-extract-plugin
export default {"wrapper":"phone-code_wrapper_AzgpO","login":"phone-code_login_PrT_i","code":"phone-code_code_SHZag"};